const app_config = {
  appId: "90291072-2b26-4c0d-a2c7-f4a35356037d",
  userManagementURL: "http://46.202.163.9/fa",
};

export default app_config;
